export default __webpack_public_path__ + "static/media/dashboard.1471b3f9.png";